import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteSoilSightScenario } from "services";

import { useIsAuthenticated } from "utils";

import { DELETE_SOIL_SIGHT_SCENARIO, GET_SOIL_SIGHT_PROJECT, GET_SOIL_SIGHT_SCENARIO, LIST_SOIL_SIGHT_PROJECTS, LIST_SOIL_SIGHT_SCENARIOS } from "consts";

import { SoilSightProjectResponse, SoilSightScenario } from "models";

export const useDeleteSoilSightScenario = () => {
  const queryClient = useQueryClient();
  const isAuthenticated = useIsAuthenticated();

  return useMutation({
    mutationKey: [DELETE_SOIL_SIGHT_SCENARIO],
    mutationFn: (scenarioId: string) => {
      if (!isAuthenticated) return Promise.reject(new Error("Not Authorized"));
      return deleteSoilSightScenario(scenarioId);
    },
    // Drop the detail cache and filter the scenario out of every cached list,
    // bypassing invalidation so any in-flight subscriber doesn't refetch.
    onSuccess: (_data, scenarioId) => {
      // Find the soilSightProjectId that owns this scenario before removing it from the list cache.
      const allScenarioLists = queryClient.getQueriesData<SoilSightScenario[]>({ queryKey: [LIST_SOIL_SIGHT_SCENARIOS] });
      const ownerKey = allScenarioLists.find(([, scenarios]) => scenarios?.some((s) => s.id === scenarioId))?.[0];
      const soilSightProjectId = Array.isArray(ownerKey) && typeof ownerKey[1] === "string" ? ownerKey[1] : null;

      queryClient.removeQueries({ queryKey: [GET_SOIL_SIGHT_SCENARIO, scenarioId], exact: true });
      queryClient.setQueriesData<SoilSightScenario[] | undefined>({ queryKey: [LIST_SOIL_SIGHT_SCENARIOS] }, (old) =>
        old ? old.filter((s) => s.id !== scenarioId) : old
      );

      const projectData = soilSightProjectId ? queryClient.getQueryData<SoilSightProjectResponse>([GET_SOIL_SIGHT_PROJECT, soilSightProjectId]) : null;
      queryClient.invalidateQueries({ queryKey: projectData?.farmId ? [LIST_SOIL_SIGHT_PROJECTS, projectData.farmId] : [LIST_SOIL_SIGHT_PROJECTS] });
    },
  });
};
